import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleConfigure = () => {
    localStorage.setItem('cookieConsent', 'configured');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-2xl rounded-t-2xl border-t border-gray-200 p-4 sm:p-6 animate-slide-up max-w-full overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0 gap-4">
        <p className="text-xs sm:text-sm text-gray-700 flex-1 text-center md:text-left">
          Usamos cookies para mejorar tu experiencia. Al continuar, aceptas nuestra política de cookies.
        </p>
        <div className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0">
          <button
            onClick={handleConfigure}
            className="px-4 sm:px-6 py-2 border border-gray-300 text-gray-700 rounded-full text-xs sm:text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Configurar
          </button>
          <button
            onClick={handleAccept}
            className="px-4 sm:px-6 py-2 bg-teal-600 text-white rounded-full text-xs sm:text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Aceptar
          </button>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-2 sm:top-4 right-2 sm:right-4 text-gray-400 hover:text-gray-600 cursor-pointer"
        >
          <i className="ri-close-line text-lg sm:text-xl"></i>
        </button>
      </div>
    </div>
  );
}
